import { LoggerPayload } from 'libs/end-to-end/src/isomorphic-logger';
import { Result } from 'libs/end-to-end/src/result';
import { withRetrier } from 'libs/end-to-end/src/retrier';
import { BaseError } from 'libs/end-to-end/src/types/errors/base-error';
import { isUnknownError } from 'libs/end-to-end/src/types/errors/unknown-error';

export const withSocketTimeoutRetry = <
  Args extends {
    logger: LoggerPayload;
  },
  T,
  E extends BaseError,
  Return extends Result<T, E>,
>(
  fn: (operationParameters: Args) => Promise<Return>,
) => {
  return withRetrier({
    maxAttempts: 3,
    fn,
    criteriaFn: (result) => {
      return (
        result.resultType === 'err' &&
        (result.error.errorType === 'S3StorageUploadError' ||
          result.error.errorType === 'S3StorageDownloadError' ||
          result.error.errorType === 'S3StorageHeadError' ||
          result.error.errorType === 'S3StorageCopyError' ||
          result.error.errorType === 'HttpRequestFailedError' ||
          result.error.errorType === 'S3StorageSlowDownError' ||
          (isUnknownError(result.error) &&
            result.error.errorReason.toLowerCase().includes('terminated')))
      );
    },
    notifyFn: ({ attempt, maxAttempts, result, logger }) => {
      logger.info(
        `There was a socket failure that we may be able to tolerate. Attempt ${attempt} of ${maxAttempts}.`,
        result,
      );
    },
  });
};
